<template>
  <fwb-navbar class="bg-black relative flex justify-between items-center w-full h-16 px-4">
      <!-- Menú para desktop -->
      <div class="hidden sm:block relative ml-auto">
        <button @click="toggleDropdown" class="flex items-center px-4 text-white hover:text-gray-300 focus:outline-none">
          <!-- Avatar del usuario -->
          <div class="flex items-center mr-3">
            <!-- Avatar con imagen -->
            <img 
              v-if="hasImage" 
              :src="profile_img" 
              class="w-10 h-10 rounded-full object-cover"
              :alt="full_name"
            />
            <!-- Avatar con iniciales -->
            <div 
              v-else
              class="relative inline-flex items-center justify-center w-10 h-10 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-600"
            >
              <span class="font-medium text-gray-600 dark:text-gray-300">{{ userInitials }}</span>
            </div>
          </div>
          
          <div class="flex flex-col justify-start items-start">
            <span class="text-sm">{{ full_name || 'Usuario' }}</span>
            <div class="text-xs text-gray-400 mt-1">{{ userSession?.role || 'Asesor' }}</div>
          </div>

          <svg 
            class="w-4 h-4 ml-2"
            :class="{'rotate-180': isDropdownOpen}"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path 
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>

        <!-- Dropdown menu -->
        <div 
          v-show="isDropdownOpen" 
          class="absolute right-0 mt-5 w-48 bg-white rounded-md shadow-lg z-50 border border-gray-200"
        >
          <div class="py-1">
            <!-- Ver Perfil -->
            <router-link 
              to="/info-profile" 
              @click="closeDropdown"
              class="flex items-center px-4 py-2 text-sm text-custom_gray hover:bg-gray-100 hover:text-gray-500"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 9C16 10.0609 15.5786 11.0783 14.8284 11.8284C14.0783 12.5786 13.0609 13 12 13C10.9391 13 9.92172 12.5786 9.17157 11.8284C8.42143 11.0783 8 10.0609 8 9C8 7.93913 8.42143 6.92172 9.17157 6.17157C9.92172 5.42143 10.9391 5 12 5C13.0609 5 14.0783 5.42143 14.8284 6.17157C15.5786 6.92172 16 7.93913 16 9ZM14 9C14 9.53043 13.7893 10.0391 13.4142 10.4142C13.0391 10.7893 12.5304 11 12 11C11.4696 11 10.9609 10.7893 10.5858 10.4142C10.2107 10.0391 10 9.53043 10 9C10 8.46957 10.2107 7.96086 10.5858 7.58579C10.9609 7.21071 11.4696 7 12 7C12.5304 7 13.0391 7.21071 13.4142 7.58579C13.7893 7.96086 14 8.46957 14 9Z" fill="#737373"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12C1 18.075 5.925 23 12 23C18.075 23 23 18.075 23 12C23 5.925 18.075 1 12 1ZM3 12C3 14.09 3.713 16.014 4.908 17.542C5.74744 16.4401 6.83015 15.5471 8.07164 14.9327C9.31312 14.3183 10.6798 13.9991 12.065 14C13.4324 13.9984 14.7821 14.3091 16.0111 14.9084C17.2402 15.5077 18.3162 16.3797 19.157 17.458C20.0234 16.3216 20.6068 14.9952 20.8589 13.5886C21.111 12.182 21.0244 10.7355 20.6065 9.36898C20.1886 8.00243 19.4512 6.75505 18.4555 5.73004C17.4598 4.70503 16.2343 3.93186 14.8804 3.47451C13.5265 3.01716 12.0832 2.88877 10.6699 3.09997C9.25652 3.31117 7.91379 3.85589 6.75277 4.68905C5.59175 5.52222 4.64581 6.61987 3.99323 7.8912C3.34065 9.16252 3.00018 10.571 3 12ZM12 21C9.93391 21.0033 7.93014 20.2926 6.328 18.988C6.97281 18.0646 7.83119 17.3107 8.83008 16.7905C9.82896 16.2702 10.9388 15.999 12.065 16C13.1772 15.999 14.2735 16.2635 15.263 16.7713C16.2524 17.2792 17.1064 18.0158 17.754 18.92C16.1395 20.267 14.1026 21.0033 12 21Z" fill="#737373"/>
              </svg>
              <span class="ml-3">Ver Perfil</span>
            </router-link>
            
            <!-- Separador -->
            <div class="border-t border-gray-100"></div>
            
            <!-- Cerrar Sesión -->
            <button 
              @click="outsession"
              class="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 hover:text-red-700"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 18 19" fill="none">
                <path d="M5.25 4H7.5C7.63828 4 7.75 4.11182 7.75 4.25C7.75 4.38818 7.63828 4.5 7.5 4.5H5.25C4.55953 4.5 4 5.06093 4 5.75V13.25C4 13.9391 4.55953 14.5 5.25 14.5H7.5C7.63828 14.5 7.75 14.6118 7.75 14.75C7.75 14.8882 7.63828 15 7.5 15H5.25C4.28564 15 3.5 14.2144 3.5 13.25V5.75C3.5 4.78564 4.28564 4 5.25 4ZM11.0732 6.32324C11.1712 6.22525 11.3288 6.22525 11.4268 6.32324L14.4258 9.32227C14.4368 9.3333 14.447 9.34584 14.4561 9.35938L14.4805 9.40527C14.5052 9.46552 14.5052 9.53448 14.4805 9.59473C14.4661 9.62939 14.4473 9.6564 14.4277 9.67578L11.4268 12.6768C11.3778 12.7257 11.3145 12.75 11.25 12.75C11.1855 12.75 11.1222 12.7257 11.0732 12.6768C10.9753 12.5788 10.9753 12.4212 11.0732 12.3232L13.6465 9.75H6C5.86172 9.75 5.75 9.63818 5.75 9.5C5.75 9.36182 5.86172 9.25 6 9.25H13.6465L11.0732 6.67676C10.9753 6.57877 10.9753 6.42123 11.0732 6.32324Z" fill="#374151" stroke="#D41818"/>
              </svg>
              <span class="ml-3">Cerrar Sesión</span>
            </button>
          </div>
        </div>
      </div>
  </fwb-navbar>
</template>

<script setup>
import {
  FwbNavbar
} from "flowbite-vue";
import { computed, ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import axios from "axios";

const store = useStore();
const userSession = computed(() => store.getters.getUserSession);
const session = computed(() => store.getters.getUserSession);
const isDropdownOpen = ref(false);

// Variables para el avatar siguiendo el patrón de NavBarComponent
const hasImage = ref(false);
const profile_img = ref(require("@/assets/imgs/broker_default.png"));
const full_name = ref('');

// Computed para generar las iniciales del usuario
const userInitials = computed(() => {
  const names = full_name.value.trim().split(' ');
  if (names.length >= 2) {
    return (names[0].charAt(0) + names[1].charAt(0)).toUpperCase();
  } else if (names.length === 1) {
    return names[0].substring(0, 2).toUpperCase();
  }
  return '';
});

// Función para obtener datos del perfil desde la API (similar a FormAgentComponent)
const getProfile = async () => {
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };
    
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}`,
      options
    );

    if (response.status === 200) {
      // Obtener el nombre completo del perfil
      full_name.value = response.data.resp.info.full_name;
      
      // Obtener la imagen del avatar desde el perfil
      profile_img.value = response.data.resp.info.profile_avatar;
      
      // Verificar si hay imagen real
      if (response.data.resp.info.profile_avatar) {
        hasImage.value = true;
      } else {
        hasImage.value = false;
      }
    }
  } catch (error) {
    //console.error("Error fetching profile data:", error);
    // Si hay error, usar los datos de la sesión como fallback
    //loadUserDataFromSession();
  }
};

/* Función de fallback: cargar datos del usuario desde la sesión
const loadUserDataFromSession = () => {
  if (session.value) {
    full_name.value = session.value.name;
    profile_img.value = session.value.avatar;
    
    // Verificar si hay imagen real
    if (session.value.avatar) {
      hasImage.value = true;
    } else {
      hasImage.value = false;
    }
  }
};*/

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

const closeDropdown = () => {
  isDropdownOpen.value = false;
};

async function outsession() {
  await store.dispatch("clearUserSession");
  window.location.replace("/login");
}

onMounted(async () => {
  // Esperar a que la sesión esté disponible
  if (!session.value) {
    await store.dispatch("loadUserSession");
  }

  // Obtener datos del perfil desde la API
  await getProfile();

  // Agregar listener para cerrar dropdown al hacer clic fuera
  // Cerrar dropdown al hacer clic fuera de él
  document.addEventListener('click', (event) => {
    const dropdown = event.target.closest('.relative');
    if (!dropdown && isDropdownOpen.value) {
      isDropdownOpen.value = false;
    }
  });
});

onBeforeUnmount(() => {
  document.removeEventListener('click', closeDropdown);
});
</script>

<style scoped>
/* Estilos para el dropdown */
.relative {
  position: relative;
}

/* Transiciones suaves para el dropdown */
.dropdown-enter-active, .dropdown-leave-active {
  transition: all 0.2s ease;
}

.dropdown-enter-from, .dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Asegurar que el dropdown esté por encima de otros elementos */
.z-50 {
  z-index: 50;
}

/* Estilos para las transiciones del icono */
.rotate-180 {
  transform: rotate(180deg);
}

svg {
  transition: transform 0.2s ease;
}
</style>
